import { render, staticRenderFns } from "./BlockImageGallery.vue?vue&type=template&id=28ba33d6"
import script from "./BlockImageGallery.vue?vue&type=script&lang=js"
export * from "./BlockImageGallery.vue?vue&type=script&lang=js"
import style0 from "./BlockImageGallery.vue?vue&type=style&index=0&id=28ba33d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports